import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/pastDuePerformanceSagas";

export const UpdateButtons = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.pastDuesPerformance.filtersDirty);

  return (
    filtersDirty && (
      <>
        <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
          Update
        </button>

        <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
          Reset
        </button>
      </>
    )
  );
};
